import React, {Component} from "react";

import axios from 'axios';
import Constants from '../../../components/Constants/';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class Symptoms extends Component {

  constructor(props) {
    super(props);

    this.refreshSymptomsList = this.refreshSymptomsList.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.onAddSymptom = this.onAddSymptom.bind(this);

    this.state = {
        symptomsList: null,
        activePage: 1
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }

      this.refreshSymptomsList();
    }

    refreshSymptomsList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/symptom'
      })
      .then(response => {
          this.setState({
              symptomsList: response.data
          });
      });
    }

    statusFormatter(cell, row){
      return (
        cell == "ACTIVE" ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>
      );
    }

    actionsFormatter(cell, row){
      return (
        <Button color="info" onClick={() => { alert(cell); }}><i className="fa fa-pencil"></i></Button>
      );
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    afterSaveCell(row, cellName, cellValue) {
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/symptom',
          data: row
      })
      .then(response => {
        this.msg.show('Sintoma salvo.', {
          time: 10000,
          type: 'success'
        });
      });
    }

    onAddSymptom(row) {

      row.id = null;
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/symptom',
          data: row
      })
      .then(response => {
          this.msg.show('Sintoma adicionado.', {
            time: 10000,
            type: 'success'
          });
          this.refreshAntecedentsList();
      });
    }

    createCustomModalHeader(closeModal, save){
      return (
        <InsertModalHeader
          className='model-header'
          title=''
         />
      );
    }


    render() {
      if(this.state.symptomsList == null) return null;

      const tableOptions = {
        paginationSize: 10,
        hideSizePerPage: true,
        paginationShowsTotal: true,
        paginationShowsTotal: this.renderPaginationShowsTotal,
        onAddRow: this.onAddSymptom,
        insertModalHeader: this.createCustomModalHeader,
        sortIndicator: true
      };

      const statusTypes = [ {
        value: 'ACTIVE',
        text: 'Ativo'
      }, {
        value: 'INACTIVE',
        text: 'Inativo'
      }];

      const cellEdit = {
        mode: 'dbclick',
        blurToSave: true,
        afterSaveCell: this.afterSaveCell,
      };

      return(
          <div>
            <h2>Sintomas</h2>
            <hr />
            <BootstrapTable ref="table" data={this.state.symptomsList} version='4'
              striped hover pagination insertRow search searchPlaceholder='Pesquisa Geral'
              options={tableOptions} cellEdit={ cellEdit }>
              <TableHeaderColumn dataField="description" dataSort={true} width='40%'>Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="status" editable={ { type: 'select', options: { values: statusTypes } } } dataFormat={this.statusFormatter} dataSort={true} width='25%'>Status</TableHeaderColumn>
              <TableHeaderColumn dataField="id" autoValue isKey={true} width='25%'>ID</TableHeaderColumn>

            </BootstrapTable>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default Symptoms;



// WEBPACK FOOTER //
// ./src/views/admin/Symptoms/Symptoms.js